import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  teams: [], // Initial teams array
  isDefaultSet: false,
};

const teamSlice = createSlice({
  name: 'team',
  initialState,
  reducers: {
    setTeams: (state, action) => {
      state.teams = action.payload;
      state.isDefaultSet = action.payload.some((team) => team.isDefault);
    },
    addTeam: (state, action) => {
      state.teams.push(action.payload);
      if (action.payload.isDefault) {
        state.isDefaultSet = true;
      }
    },
    updateTeam: (state, action) => {
      
      const updatedTeam = action.payload;

      const prevTeam = state.teams.find(team => team.id === updatedTeam.id );

      let updatedPrevTeams = state.teams;

      if ( ! prevTeam.isDefault && updateTeam.isDefault ) {
        // Set isDefault to false for previous default teams
        updatedPrevTeams = state.teams.map((prevTeam) =>
          prevTeam.isDefault
            ? { ...prevTeam, isDefault: false }
            : prevTeam
        );

        state.isDefaultSet = true;
      }

      state.teams = updatedPrevTeams.map((prevTeam) =>
        prevTeam.id === updatedTeam.id ? updatedTeam : prevTeam
      );

    },
    deleteTeam: (state, action) => {
      state.teams = state.teams.filter((team) => team.id !== action.payload)
    },
    setIsDefaultSet: (state, action) => {
      state.isDefaultSet = action.payload;
    },
  },
});

export const { setTeams, addTeam, updateTeam, deleteTeam, setIsDefaultSet, } = teamSlice.actions;

export default teamSlice.reducer;